import { initApp } from './ui/app.js';

// Boot the application when the DOM is ready
initApp();
